import TimelineSeparator from '@material-ui/lab/TimelineSeparator';

export default TimelineSeparator;
